import { useState } from "react"
import { toast } from 'react-hot-toast';
import ajaxCard from "../../util/remote/ajaxCard";
import Loader from "../Common/Loader";
import SystemModal from "../Common/SystemModal";
import TableHeader from "../Common/TableHeader";
import { Link } from "react-router-dom";


const AssignCard=(props)=>{
    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [card,setCard] =useState("")
    const [cardNumber,setCardNumber] =useState("")
    const [cardType,setCardType] =useState("")

    const page = 1;
    const [query, setQuery] = useState("");
    const [cardSearch, setCardSearch] = useState(null);

    const [active1,setActive1] = useState(false)
    const handleActive1 = ()=> setActive1(true)
    const handleInActive1 = ()=> setActive1(false)

    const data={
        student_id: props.studentID,
        card_id: card,
    }

    const setDetails = (e,item) =>{
        e.preventDefault()
        handleActive1()
        setCard(item.card_id)
        setCardNumber(item.card_number)
        setCardType(item.type)
        
    }

    const backPage = (e) =>{
        e.preventDefault()
        handleInActive1()
    }

    const setCards = (e) => {
        e.preventDefault();
        setCardSearch(false);
        setQuery("");
      };

    const searchCard = async (e) => {
        if (e) {
          e.preventDefault();
        }
          setLoading2(true);
          const server_response = await ajaxCard.searchCard(query,page);
          setLoading2(false);
          if (server_response.status === "OK") {
            if (server_response.details.length === 0) {
              setCardSearch([]);
            } else {
              setCardSearch(server_response.details.data);
            }
          } else {
            setCardSearch("404");
          }
    };

    const handleAdd = async(e) =>{
        e.preventDefault()
        if (card.length > 0) {
            setLoading(true)
            const server_response = await ajaxCard.attachCard(data);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                props.g();
            }
            else{
                toast.error(server_response.message); 
            }
        } else {
            toast.error("Please select a student!");
          } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    {active1 &&<button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleAdd}>Assign Card / Wristband<i class="fas fa-check mg-l-15"></i></button>}
                    </>
        }
    }

    return(
        <SystemModal
            title="Assign Card / Wristband"
            id="model-assign-card-to-student"
            size="lg"
            footer={RenderFooter}
        >

{active1?<><div className="pl-20">
    <Link onClick={backPage}  className="btn btn-info mr-2"><i className="far fa-circle-left mr-1"></i>Card / Wristband Search</Link>
          </div>
              <div className="rfid_card_body">
              
                <div class="rfid_card">
	                <div class="rfid_card__info">
                  <div class="rfid_card__logo"><b>Confirm Details:</b></div>
		                    <div class="rfid_card__number">
                        <span class="rfid_card__digit-group">Serial Number: {cardNumber}</span>
		                    </div>
                        <div class="rfid_card__name">Type: {cardType}</div>
                        <div class="rfid_card__name">Student Name: {props.fullName}</div>
		                   
	</div>
	
</div>
              </div></>:<><div className="row gutters-8">
                  <div className="col-9-xxxl col-xl-6 col-lg-6 col-6 form-group">
                    <input
                      type="text"
                      value={query}
                      style={{border: "1px solid grey"}}
                      onChange={(e) => {
                        setQuery(e.target.value);
                        if (e.target.value === '') {
                          setCards(e);
                        }
                      }}
                      placeholder="Search for card / wristband number..."
                      className="form-control"
                    />
                  </div>
                  <div className="col-3-xxxl col-xl-6 col-lg-6 col-6 form-group">
                    <button
                      type="submit"
                      onClick={(e) => searchCard(e)}
                      className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue">
                      SEARCH
                    </button>
                  </div>
                </div>
                
                <div className="card-body map-card">
                        <TableHeader
                            title="Search Result(s)"
                                
                        />
                        <div className="border-top mt-3"></div>                    
                        <div className="table-responsive">
                            <table className="table table-hover text-nowrap mg-b-0">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col"> Serial Number</th>
                                        <th scope="col"> Type</th>
                                        <th scope="col"> Status</th>
                                        <th scope="col"> Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(cardSearch) && cardSearch.map((item, key) => (
                                            
                                             <tr key={key} >
                                                <th scope="row">{key+1}</th>
                                                <td>{item.card_number}</td>
                                                <td>{item.type==="CARD"?<span class="badge badge-info">{item.type}</span>:<span class="badge badge-wb">{item.type}</span>}</td>
                                                <td>{item.status==="1"?<span class="badge badge-success">Assigned</span>
                                                  :item.status==="0"?<span class="badge badge-warning">Unassigned</span>
                                                  :<span class="badge badge-danger">De-activated</span>}</td>
                                                <td>
                                                  <button disabled={item.status==="1"} type="button" onClick={(e)=>setDetails(e,item)} className={`btn-fill-md text-light ${item.status==="1" ? "bg-martini" : "bg-dodger-blue"}`}
                                                >Select <i class="fas fa-check"></i></button>
                                                </td>
                                            </tr>
                                        ))}
                                        {cardSearch === "404" && (<tr>
                          <td colSpan="5" style={{textAlign: "center"}}>
                            No search result(s) found.
                          </td>
                        </tr>)}
                                </tbody>
                            </table>
                            {loading2 && <Loader/>}
                        </div>
                              
                    </div></>}
       
        </SystemModal>
    )
}

export default AssignCard
